export default __webpack_public_path__ + "static/media/Etape-7_Pyramide_DEF.538688c0.mp3";